import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import 'src/style/createVehicleTracking.css';
import { ReactComponent as ArrowLeft } from 'src/Images/icons/common/arrowleft.svg';
import { ReactComponent as ArrowRight } from 'src/Images/icons/common/arrowright.svg';
import OutwardVehicleTrackingHeaderSection from 'src/components/VehicleTrackingCreate/Outward/OutwardVehicleTrackingHeaderSection';
import OutwardVehicleTrackingAttachDeliverySection from 'src/components/VehicleTrackingCreate/Outward/OutwardVehicleTrackingAttachDeliverySection';
import OutwardVehicleTrackingSelectedDocumentsSection from 'src/components/VehicleTrackingCreate/Outward/OutwardVehicleTrackingSelectedDocumentsSection';
import AccessControl from 'src/components/AccessControl';
import { ACTIONS } from 'src/utils/roles/actions';

function CreateOutwardVehicleTrackingBasicDetails({
  formData,
  selectedDeliveryOrder,
  setSelectedDeliveryOrder,
  handleOnChange,
  setFormData,
  transporterSearchTerm,
  setTransporterSearchTerm,
  vehicleSearchTerm,
  setVehicleSearchTerm,
  errorField,
  handleDeleteDeliveryOrder,
  selectedBusinessPartner,
  setSelectedBusinessPartner,
}) {
  const authReducer = useSelector((state) => state.AuthReducer);
  const themeColor = authReducer?.userData?.tenant?.theme;
  const [showSelectedDocuments, setShowSelectedDocuments] = useState(false);

  return (
    <div className="create-form-container">
      <Row className="g-0 create-form-row">
        <Col
          className={`theme-scrollable-container-${themeColor} scrollable-container selected-documents-main-col`}
        >
          <div className="col-container">
            {/* vehicle tracking for outward basic detail header section card */}
            <OutwardVehicleTrackingHeaderSection
              formData={formData}
              handleOnChange={handleOnChange}
              setFormData={setFormData}
              transporterSearchTerm={transporterSearchTerm}
              setTransporterSearchTerm={setTransporterSearchTerm}
              vehicleSearchTerm={vehicleSearchTerm}
              setVehicleSearchTerm={setVehicleSearchTerm}
              errorField={errorField}
            />

            {/* select delivery order card */}
            <AccessControl action={ACTIONS.VEHICLE_TRACKING.OUTWARD.PLAN}>
              <OutwardVehicleTrackingAttachDeliverySection
                formData={formData}
                selectedDeliveryOrder={selectedDeliveryOrder}
                setSelectedDeliveryOrder={setSelectedDeliveryOrder}
                handleOnChange={handleOnChange}
                selectedBusinessPartner={selectedBusinessPartner}
                setSelectedBusinessPartner={setSelectedBusinessPartner}
              />
            </AccessControl>
          </div>
        </Col>
        <Col
          className={`selected-documents-drawer-col ${
            showSelectedDocuments
              ? 'selected-documents-drawer-expanded'
              : 'selected-documents-drawer-collapsed'
          }`}
        >
          {!showSelectedDocuments && (
            <button
              type="button"
              className="selected-documents-edge-btn"
              onClick={() =>
                setShowSelectedDocuments((currentValue) => !currentValue)
              }
              aria-label="Show selected documents"
              title="Show Selected Documents"
            >
              <ArrowLeft className="icon-size-sm" />
            </button>
          )}
          {showSelectedDocuments && (
            <AccessControl action={ACTIONS.VEHICLE_TRACKING.OUTWARD.PLAN}>
              <div className="selected-documents-expanded-card">
                <OutwardVehicleTrackingSelectedDocumentsSection
                  selectedDeliveryOrder={selectedDeliveryOrder}
                  errorField={errorField}
                  handleDeleteDeliveryOrder={handleDeleteDeliveryOrder}
                  titlePrefix={
                    <button
                      type="button"
                      className="selected-documents-inline-btn"
                      onClick={() =>
                        setShowSelectedDocuments(
                          (currentValue) => !currentValue,
                        )
                      }
                      aria-label="Hide selected documents"
                      title="Hide Selected Documents"
                    >
                      <ArrowRight className="icon-size-sm" />
                    </button>
                  }
                />
              </div>
            </AccessControl>
          )}
        </Col>
      </Row>
    </div>
  );
}

export default CreateOutwardVehicleTrackingBasicDetails;
